import type { ElementType } from "react";
import { cn } from "@/lib/utils";

export function NotificationKpiCard({
  label,
  value,
  detail,
  icon: Icon,
  tone,
}: {
  label: string;
  value: number;
  detail: string;
  icon: ElementType;
  tone: "gold" | "danger" | "warning" | "neutral";
}) {
  const toneClasses = {
    gold: "border-brand-gold-dark/25 bg-brand-gold-light/35 text-brand-gold-dark",
    danger: "border-danger-border bg-danger-bg text-danger-text",
    warning: "border-warning-border bg-warning-bg text-warning-text",
    neutral: "border-border bg-card text-muted-foreground",
  }[tone];

  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-[10.5px] font-semibold uppercase tracking-wide text-muted-foreground">
            {label}
          </p>
          <p className="mt-1 text-2xl font-bold tabular-nums text-foreground">{value}</p>
          <p className="mt-1 text-[11px] text-muted-foreground">{detail}</p>
        </div>
        <div className={cn("rounded-full border p-2", toneClasses)}>
          <Icon size={15} />
        </div>
      </div>
    </div>
  );
}
